import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  KeycloakEvent,
  KeycloakEventType,
  KeycloakService,
} from "keycloak-angular";
import { Subject, takeUntil } from "rxjs";
import { Store } from "@ngxs/store";
import {
  GetSitesAction,
  GetUserAction,
} from "./core/user-profile/store/user-profile.actions";
import { GetSettingsAction } from "./shared/store/settings.actions";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  title = "Cyberquest Hub";
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly keycloakService: KeycloakService,
    private store: Store,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.store.dispatch([GetUserAction, GetSitesAction, GetSettingsAction]);

    this.keycloakService.keycloakEvents$
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (event: KeycloakEvent) => {
          if (event.type == KeycloakEventType.OnTokenExpired) {
            this.keycloakService.logout();
          } else if (event.type == KeycloakEventType.OnAuthRefreshError) {
            this.keycloakService.logout();
          }
        },
      });

    let language = sessionStorage.getItem("lang");
    if (language) this.translate.use(language);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
